import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import {
    Button,
    Icon,
    LinearProgress,
    TextField,
    Typography,
} from '@material-ui/core'

import Page from '../../components/Page'
import { connect } from 'react-redux'
import {
    addSku,
    removeSku,
    importProduct,
    importProducts,
    getImportQueue,
} from '../../actions/ProductImportActions'
import List from '../../components/List'

const styles = theme => ({
    button: {
        margin: theme.spacing.unit,
        marginLeft: 0,
    },

    leftIcon: {
        marginRight: theme.spacing.unit,
    },
})

class ProductImportPage extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            skus: '',
        }
    }

    componentDidMount() {
        this.props.getImportQueue(this.props.page, this.props.pageSize)
        this.pollInterval = setInterval(() => {
            this.props.getImportQueue(this.props.page, this.props.pageSize)
        }, 1000)
    }

    componentWillUnmount() {
        clearInterval(this.pollInterval)
    }

    addSkus = () => {
        const skus = this.state.skus.split(',').map(item => item.trim())

        this.props.importProducts(skus)

        this.setState({ skus: '' })
    }

    render() {
        const { classes } = this.props

        const columns = [
            { name: 'Produkt' },
            { name: 'Status importu' },
            { name: 'Data utworzenia' },
        ]

        const stateColumn = state => {
            switch (state) {
                case 'NEW':
                    return 'Nowy'

                case 'IN_PROGRESS':
                    return 'W trakcie'

                case 'COMPLETED':
                    return 'Zakończony'

                case 'FAILED':
                    return 'Niepowodzenie'

                default:
                    return state
            }
        }

        const values = Object.values(this.props.items).map(item => {
            return {
                actions: [],
                columns: [item.sku, stateColumn(item.state), item.createdAt],
            }
        })

        return (
            <Page
                pageTitle="Import produktów"
                headerIcon={
                    <Icon className="text-32 mr-0 sm:mr-12">
                        local_shipping
                    </Icon>
                }
                content={
                    <>
                        <div>
                            <TextField
                                className="mb-16 mr-16"
                                variant="outlined"
                                label="Lista sku po przecinku"
                                value={this.state.skus}
                                onChange={event =>
                                    this.setState({ skus: event.target.value })
                                }
                                onKeyPress={event => {
                                    if (event.key === 'Enter') {
                                        this.addSkus()
                                    }
                                }}
                            />
                            <Button
                                className={classes.button}
                                variant="contained"
                                color="secondary"
                                onClick={() => this.addSkus()}
                            >
                                Dodaj do importu
                            </Button>
                        </div>
                        {this.props.importInProgress && (
                            <div className="mb-16">
                                <Typography variant="caption" className="mb-8">
                                    Import w toku:{' '}
                                    {this.props.importProcessedChunks} /{' '}
                                    {this.props.importTotalChunks} paczek
                                    przetworzonych
                                </Typography>
                                <LinearProgress
                                    variant="buffer"
                                    value={Math.round(
                                        (this.props.importProcessedChunks /
                                            this.props.importTotalChunks) *
                                            100
                                    )}
                                    valueBuffer={Math.min(
                                        Math.round(
                                            ((this.props.importProcessedChunks +
                                                1) /
                                                this.props.importTotalChunks) *
                                                100
                                        ),
                                        100
                                    )}
                                />
                            </div>
                        )}
                        <div>
                            <List
                                values={values}
                                columns={columns}
                                loading={this.props.loading}
                                onChangePage={(_e, page) =>
                                    this.props.getImportQueue(
                                        page + 1,
                                        this.props.pageSize
                                    )
                                }
                                onChangeRowsPerPage={event => {
                                    this.props.getImportQueue(
                                        this.props.page,
                                        event.target.value
                                    )
                                }}
                                page={this.props.page - 1}
                                paginated
                                rowsPerPage={this.props.pageSize}
                                count={this.props.total}
                            />
                        </div>
                    </>
                }
            />
        )
    }
}

const mapStateToProps = ({ presto }) => {
    return presto.productImport
}

const ProductImport = connect(mapStateToProps, {
    addSku,
    removeSku,
    importProduct,
    importProducts,
    getImportQueue,
})(withStyles(styles)(ProductImportPage))

export default ProductImport
